<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <conc-type
          :default-conc-type.sync="concType"
          @change="onConcTypeChange"
        />
      </template>

      <charts
        v-for="data in dataList"
        :key="data.id"
        ref="data-renders"
        :data="data"
        :query="currentQuery"
        :conc-type="concType"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteData from '../../../BaseSiteData'
import DataWrapper from '../../../../components/Data/DataWrapper'
import Charts from './Charts'
import unitConverter from '../../../../utils/unitConverter'
import Constant from '../../../../model/Constant'

export default {
  name: 'AQIRelated',
  routeInfo: {
    label: '相关性分析',
    icon: 'fa fa-users'
  },
  extends: BaseSiteData,
  components: {Charts, DataWrapper},
  data () {
    return {
      query: {
        factorIds: ['1001', '1002', '1003', '1004', '1005', '1006', '1007', '1008'],
        isFuse: false,
        isAuditCompleted: false,
        isGetInvalidData: true
      },
      concType: 1,
      noDataList: Object.freeze([])
    }
  },
  computed: {
    deviceCategories: () => [[
      process.env.SO2_DEVICE_CATEGORY,
      process.env.NO_DEVICE_CATEGORY,
      process.env.CO_DEVICE_CATEGORY,
      process.env.O3_DEVICE_CATEGORY,
      process.env.PM_DEVICE_CATEGORY,
      process.env.OCEC_DEVICE_CATEGORY,
      process.env.HEAVY_METAL_DEVICE_CATEGORY,
      process.env.HEAVY_METAL_DEVICE_CATEGORY
    ], 1],
    noDataReasonMap () {
      const {filterSiteMap} = this
      return this.noDataList.reduce((map, noData) => {
        const {siteId} = noData
        const site = filterSiteMap[siteId]

        if (site) {
          const {siteDeviceId} = noData
          const siteDevice = site.devices.find(siteDevice => siteDevice.id === siteDeviceId)

          if (siteDevice) {
            const dataTime = `${noData.dataTime}:00:00`
            siteDevice.siteDeviceFactors.reduce((map, siteDeviceFactor) => {
              map[`${siteId}-${siteDeviceFactor.factorId}-${dataTime}`] = noData
              return map
            }, map)
          }
        }
        // map[`${noData.siteId}-${noData.siteDeviceId}-${noData.dataTime}:00:00`] = noData
        return map
      }, {})
    }
  },
  methods: {
    onAuditCompletedChanged () {
      let {query} = this
      if (query.isAuditCompleted === 'isFuse') {
        query.isFuse = true
        delete query.isAuditCompleted
      } else {
        query.isFuse = false
      }
      if (query.isAuditCompleted === true) {
        query.isGetInvalidData = false
      } else {
        query.isGetInvalidData = true
      }

      this.afterSetSiteIds()
    },
    setNoDataList (noDataList) {
      const {NO_DATA_REASON_MAP} = Constant

      this.noDataList = Object.freeze(noDataList.map(noData => {
        let {cause} = noData
        const noDataReasons = []

        while (cause > 0) {
          const bin = -cause & cause
          cause ^= bin
          const noDataReason = NO_DATA_REASON_MAP[bin]

          if (noDataReason) {
            noDataReasons.push(noDataReason.label)
          }
        }

        return {
          ...noData,
          reason: noDataReasons.join(',')
        }
      }))
    },
    getData () {
      this.changeLoadStatus(true)
      Promise.all([
        this.$api.Data.getHistoryData(this.currentQuery),
        this.$api.NoData.getNoDataListBySite(this.currentQuery)
      ]).then(([dataList, noDataList]) => {
        this.setNoDataList(noDataList)
        this.tmpList = dataList
        this.formatData()
        this.renderData()
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    formatData () {
      let {currentQuery, filterSiteMap, factorMap} = this
      let beginTS = new Date(currentQuery.beginTime).getTime()
      let endTS = new Date(currentQuery.endTime).getTime()
      let timeStep = currentQuery.dataType * 60000
      let dataTimes = []

      for (let ts = beginTS; ts <= endTS; ts += timeStep) {
        dataTimes.push(new Date(ts).format('YYYY/MM/DD HH:00:00'))
      }

      let dataMap = currentQuery.siteIds.reduce((map, siteId) => {
        map[siteId] = {
          id: siteId,
          name: filterSiteMap[siteId].name,
          data: dataTimes.map(dataTime => ({
            dataTime
          }))
        }
        return map
      }, {})

      const {isAuditCompleted, isFuse} = currentQuery

      this.tmpList.concat(this.noDataList.reduce((list, noDataReason) => {
        const {siteId} = noDataReason
        const siteConfig = filterSiteMap[siteId]

        if (siteConfig) {
          const {siteDeviceId} = noDataReason
          const siteDeviceConfig = siteConfig.devices.find(siteDevice => siteDevice.id === siteDeviceId)

          if (siteDeviceConfig) {
            const {reason} = noDataReason
            const dataTime = `${noDataReason.dataTime}:00:00`
            siteDeviceConfig.siteDeviceFactors.forEach((siteDeviceFactor) => {
              list.push({
                dataTime,
                siteId,
                siteDeviceId,
                factorId: siteDeviceFactor.factorId,
                auditComment: reason
              })
            })
          }
        }

        return list
      }, []).sort((a, b) => a.dataTime.localeCompare(b.dataTime))).reduce((map, data) => {
        let dataTime = new Date(data.dataTime)
        let index = (dataTime - beginTS) / timeStep
        let siteData = map[data.siteId].data[index]
        let {factorId} = data
        let factor = factorMap[factorId]
        let {stdUnit, displayUnit, molecular, decimalNum} = factor

        if (data.auditFlag === 'DELETE' && (isAuditCompleted || isFuse)) {
          siteData[factorId] = data.auditComment
        } else if (Number.isFinite(data.value)) {
          siteData[factorId] = Number(unitConverter(data.value, stdUnit, displayUnit, molecular).toFixed(decimalNum))
        } else {
          siteData[factorId] = data.auditComment
        }

        return map
      }, dataMap)

      let dataList = Object.values(dataMap)

      dataList.forEach(siteData => {
        let siteDataList = siteData.data
        let data = siteDataList[siteDataList.length - 1]

        while (data && Object.values(data).length === 1) {
          siteDataList.pop()
          data = siteDataList[siteDataList.length - 1]
        }
      })

      this.dataList = Object.freeze(Object.values(dataMap))
      console.log(this.dataList, this.noDataReasonMap)
    },
    onConcTypeChange () {
      setTimeout(() => {
        let dataRenders = this.getDataRenders()

        if (dataRenders) {
          dataRenders.forEach(dataRender => dataRender.concTypeChange())
        }
      }, 0)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/04AQI/08Related/index.vue